module.exports = __webpack_public_path__ + "1d0fa9632771e5fb6d46ba752b38becc.png";